import { render, staticRenderFns } from "./CouponRelatedCategoryList.vue?vue&type=template&id=6ef25e9e"
import script from "./CouponRelatedCategoryList.vue?vue&type=script&lang=js"
export * from "./CouponRelatedCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports